
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2024-10-06-observable-2.0",
      function () {
        return require("private-next-pages/blogs/2024-10-06-observable-2.0/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2024-10-06-observable-2.0"])
      });
    }
  